const addLightboxToGallery = () => {
	const galleries = document.querySelectorAll('.wp-block-gallery.is-style-lightbox-gallery');

	galleries.forEach(function(gallery) {
		const images = gallery.querySelectorAll('img');
		const imageArray = Array.from(images);

		imageArray.forEach(function(image, index) {
			image.addEventListener('click', function(event) {
				event.preventDefault();

				const lightbox = document.createElement('div');
				lightbox.classList.add('farlo-ui-lightbox', 'farlo-ui-lightbox--active');

				const lightboxBackdrop = document.createElement('div');
				lightboxBackdrop.classList.add('farlo-ui-lightbox__backdrop');

				const lightboxContainer = document.createElement('div');
				lightboxContainer.classList.add('farlo-ui-lightbox__inner', 'farlo-ui-lightbox__gallery');

				const img = document.createElement('img');
				img.src = this.src;

				const closeButton = document.createElement('button');
				closeButton.classList.add('farlo-ui-lightbox__close');
				closeButton.innerHTML = '<span></span>';

				closeButton.addEventListener('click', function() {
					document.body.removeChild(lightbox);
				});

				const prevButton = document.createElement('button');
				prevButton.classList.add('farlo-ui-lightbox__gallery--prev');
				prevButton.innerHTML = '<span><</span>';
				prevButton.addEventListener('click', function() {
					showImage(index - 1);
				});

				const nextButton = document.createElement('button');
				nextButton.classList.add('farlo-ui-lightbox__gallery--next');
				nextButton.innerHTML = '<span>></span>';
				nextButton.addEventListener('click', function() {
					showImage(index + 1);
				});

				lightboxBackdrop.addEventListener('click', function(e) {
					document.body.removeChild(lightbox);
				});

				function showImage(newIndex) {
					if (newIndex < 0) {
						newIndex = imageArray.length - 1;
					} else if (newIndex >= imageArray.length) {
						newIndex = 0;
					}
					index = newIndex; // Update the index
					img.src = imageArray[ newIndex ].src;
				}

				lightboxContainer.appendChild(prevButton);
				lightboxContainer.appendChild(img);
				lightboxContainer.appendChild(nextButton);
				lightbox.appendChild(closeButton);
				lightbox.appendChild(lightboxBackdrop);
				lightbox.appendChild(lightboxContainer);
				document.body.appendChild(lightbox);
			});
		});
	});
};

export default addLightboxToGallery;
